import { render, staticRenderFns } from "./vs-form-ace.vue?vue&type=template&id=5dcecbfe&scoped=true"
import script from "./vs-form-ace.vue?vue&type=script&lang=js"
export * from "./vs-form-ace.vue?vue&type=script&lang=js"
import style0 from "./vs-form-ace.vue?vue&type=style&index=0&id=5dcecbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcecbfe",
  null
  
)

export default component.exports